export function sortObjectByProperty (objArray, prop, direction) {
  if (arguments.length < 2) throw new Error('ARRAY, AND OBJECT PROPERTY MINIMUM ARGUMENTS, OPTIONAL DIRECTION')
  if (!Array.isArray(objArray)) throw new Error('FIRST ARGUMENT NOT AN ARRAY')
  const clone = objArray.slice(0)
  const direct = arguments.length > 2 ? arguments[2] : 1 // Default to ascending
  const propPath = (prop.constructor === Array) ? prop : prop.split('.')

  clone.sort(function (a, b) {
    for (let p in propPath) {
      let valA = a[propPath[p]]
      let valB = b[propPath[p]]

      // convert numeric strings to numbers
      valA = (isNaN(valA)) ? valA : +valA
      valB = (isNaN(valB)) ? valB : +valB

      if (valA > valB) return 1 * direct
      if (valA < valB) return -1 * direct
    }
  })
  return clone
}

export function sortResourcesByProperty (resourceArray, prop, sortOrder = 1) {
  const clone = resourceArray.slice(0)

  clone.sort((a, b) => {
    if (a.attributes[prop] && b.attributes[prop]) {
      a = a.attributes[prop]
      b = b.attributes[prop]
    }

    // convert numeric strings to numbers
    a = isNaN(a) ? a : +a
    b = isNaN(b) ? b : +b
    const result = a < b ? -1 * sortOrder : a > b ? 1 * sortOrder : 0
    return result
  })
  return clone
}

/**
 * Groups data by property
 */
export function groupByProperty (arr, property) {
  if (!arr || !property || !Array.isArray(arr)) return
  return arr.reduce((acc, cur) => {
    acc[cur[property]] = [...acc[cur[property]] || [], cur]
    return acc
  }, {})
}

// const result = groupByProperties(data, (property) => [ property.prop1, property.prop2, property.prop3 ]);
export function groupByProperties (objArray, properties) {
  const groups = {}
  objArray.forEach((item) => {
    const group = JSON.stringify(properties(item))
    groups[group] = groups[group] || []
    groups[group].push(item)
  })

  return Object.keys(groups).map((group) => groups[group])
}

export function sliceIntoChunks (array, splitSize) {
  const result = []
  for (let i = 0; i < array.length; i += splitSize) {
    const chunk = array.slice(i, i + splitSize)
    result.push(chunk)
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/helpers/ObjectSorting.js